// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Popup--modalBody--3NhuF","contentWrapper":"Popup--contentWrapper--jdwec","content":"Popup--content--3dgU4","form":"Popup--form--Xb_B6","close":"Popup--close--3Xb-B"};